import { Box, styled } from "@mui/material";


export const BoxStyle = styled(Box, { shouldForwardProp: (prop) => prop !== "background" })<{ background?: string; }>(({ theme, background }) => ({
    background: background,


    [theme.breakpoints.only('xl')]: {
        width: "303px",
        height: "348px",
        paddingLeft: "12px",
        paddingRight: "12px",
    },
    [theme.breakpoints.only('lg')]: {
        width: "303px",
        height: "348px",
        paddingLeft: "12px",
        paddingRight: "12px",
    },
    [theme.breakpoints.only('md')]: {
        width: "356px",
        height: "411px",
        paddingLeft: "13px",
        paddingRight: "13px",
    },
    [theme.breakpoints.down('md')]: {
        width: "350px",
        height: "404px",
        paddingLeft: "13px",
        paddingRight: "13px",
    },

    borderRadius: "8px",

    paddingTop: "15px",
    paddingBottom: "10px",

    display: "flex",
    flexDirection: "column",
}));

export const BoxStyleTablet = styled(Box, { shouldForwardProp: (prop) => prop !== "background" })<{ background?: string; }>(({ theme, background }) => ({
    background: background,


    [theme.breakpoints.only('md')]: {
        height: "317px",
        width: "275px",
    },
    [theme.breakpoints.down('md')]: {
        width: "300px",
        height: "348px",
    },
    borderRadius: "7px",

    paddingTop: "13px",
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingBottom: "5px",

    display: "flex",
    flexDirection: "column",
}));

